export enum Locales {
  RU = 'ru',
  KZ = 'kz',
}
